<template>
  <div class="banner">
    <div class="banner-wrapper">
      <div class="banner-img">
        <img src="../../../assets/images/banner/banner-shop.jpg" alt="" />
      </div>
      <div class="min-h-screen bg-gray-50">
        <!-- 一级导航 -->
        <div class="bg-white border-t">
          <div class="max-w-7xl mx-auto px-4">
            <div class="py-3">
              <span class="text-gray-500 w-20">一级分类：</span>
              <a v-for="(item, idx) in firstLevelCategories" :key="idx">
                <span
                  :class="[item.id == oneId ? 'text-blue-600' : '']"
                  @click="getLevelTwo(item.id)"
                  >{{ item.name }}</span
                >
              </a>
            </div>
          </div>
        </div>
        <!-- 二级导航 -->
        <div class="bg-white border-t">
          <div class="max-w-7xl mx-auto px-4">
            <div class="py-3">
              <span class="text-gray-500 w-20">二级分类：</span>
              <a v-for="(item, idx) in secondLevelCategories" :key="idx">
                <span
                  :class="[item.id == twoId ? 'text-blue-600' : '']"
                  @click="getLevelThree(item)"
                  >{{ item.name }}</span
                >
              </a>
            </div>
          </div>
        </div>
        <!-- 商品列表 -->
        <div class="max-w-7xl mx-auto px-4 py-6" v-if="shopList.length > 0">
          <div class="grid grid-cols-4 gap-6">
            <div
              v-for="(product, index) in shopList"
              :key="index"
              class="bg-white p-4 rounded-lg shadow-sm"
            >
              <div
                class="aspect-w-1 aspect-h-1 aspect-h-1lg overflow-hidden rounded-lg mb-4"
              >
                <img
                  :src="product.imageUrls ? product.imageUrls[0] : ''"
                  :alt="product.name"
                  @click="toInfo(product)"
                  class="w-full curpoint h-full object-cover object-top"
                />
              </div>
              <div class="grid grid-cols-4 gap-2 mb-4">
                <div
                  v-for="(n, idx) in product.imageUrls"
                  :key="idx"
                  class="aspect-w-1 aspect-h-1 overflow-hidden rounded-md"
                >
                  <img
                    :src="n"
                    class="w-full twoimg h-full object-cover object-top transition-transform cursor-pointer"
                  />
                </div>
              </div>
              <h3 class="text-gray-900 text-sm font-medium mb-2">
                {{ product.name }}
              </h3>
              <div class="items-baseline">
                <span class="text-red-600 text-lg font-medium">¥</span>
                <span class="text-red-600 text-xl font-bold">{{
                  product.price
                }}</span>
              </div>
            </div>
          </div>
        </div>
        <!-- 分页 -->
        <div class="py-8" v-if="shopList.length > 0">
          <el-pagination
            @current-change="pageChange"
            :current-page="currentPage"
            :total="total"
            :page-size="12"
            layout="prev, pager, next"
          />
        </div>
        <div v-else class="empty">暂无数据~</div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { Loading, ElEmpty } from "element-ui";
export default {
  data() {
    return {
      currentPage: 1,
      oneId: "x",
      twoId: "xx",
      total:0,
      categories: [], // 存储原始数据
      firstLevelCategories: [], // 存储一级分类
      secondLevelCategories: [], // 存储二级分类
      shopList: [],
    };
  },
  methods: {
    pageChange(val){
      this.currentPage = val
      if (this.oneId=="x"&&this.twoId=="xx") {
        this.getNextList(undefined,undefined)
      }else if(this.oneId=="x"&&this.twoId!="xx"){
        let id = this.secondLevelCategories.filter(item=>{return item.id==this.twoId})[0].parentId
        this.getNextList(id,[this.twoId])
      }else if(this.oneId!="x"&&this.twoId=="xx"){
        this.getNextList(this.oneId,undefined)
      }else if(this.oneId!="x"&&this.twoId!="xx"){
        this.getNextList(this.oneId,[this.twoId])
      }
    },
    getList() {
      this.getNextList();
    },
    getNextList(id, ids) {
      let that = this;
      axios
        .post("http://121.40.212.122:8091/product/detail/list2", { id, ids,pageNum:that.currentPage,pageSize:12 })
        // .post("http://localhost:8091/product/detail/list2", { id, ids,pageNum:that.currentPage,pageSize:12 })
        .then(function (response) {
          that.shopList = response.data.list;
          that.total = response.data.total;
        });
    },
    getAllLevel() {
      let that = this;
      axios
        // .post("http://localhost:8091/product/category/list", {})
        .post("http://121.40.212.122:8091/product/category/list", {})
        .then(function (response) {
          that.categories = response.data.data;
          that.processCategories(response.data.data);
        });
    },
    processCategories(arr) {
      // 一级分类
      this.firstLevelCategories = [];
      this.firstLevelCategories.push({ id: "x", name: "全部" });
      arr.map((item) => {
        let obj = {
          id: item.id,
          name: item.name,
        };
        this.firstLevelCategories.push(obj);
      });
      this.getTwoAll();
    },
    // 获取二级全部的
    getTwoAll() {
      this.secondLevelCategories = this.categories.flatMap((category) =>
        (category.subCategories || []).filter(
          (sub) => !String(sub.id).includes("x")
        )
      );
      this.secondLevelCategories.unshift({ id: "xx", name: "全部" });
    },
    getLevelTwo(firstLevelId) {
      this.oneId = firstLevelId;
      this.currentPage = 1
      this.secondLevelCategories = [];
      if (firstLevelId == "x") {
        this.getTwoAll();
        this.getNextList(undefined, undefined);
      } else {
        this.secondLevelCategories =
          this.getSubCategoriesByFirstLevelId(firstLevelId);
        this.secondLevelCategories.unshift({ id: "xx", name: "全部" });
        this.getNextList(firstLevelId, undefined);
      }
    },
    getSubCategoriesByFirstLevelId(firstLevelId) {
      // 1. 找到匹配的一级分类
      const firstLevelCategory = this.categories.find(
        (item) => item.id === firstLevelId
      );
      // 2. 如果没有 subCategories，返回空数组
      if (
        !firstLevelCategory.subCategories ||
        firstLevelCategory.subCategories.length <= 0
      )
        return [];
      // 3. 过滤掉 id 包含 'x' 的二级分类
      return firstLevelCategory.subCategories.filter(
        (sub) => !String(sub.id).includes("x")
      );
    },
    getLevelThree(row) {
      let that = this;
      that.twoId = row.id;
      that.currentPage = 1
      let id = that.oneId == "x" ? row.parentId : that.oneId;
      let ids = row.id == "xx" ? undefined : [row.id];
      axios
        .post("http://121.40.212.122:8091/product/detail/list2", { id, ids,pageNum:that.currentPage,pageSize:12 })
        // .post("http://localhost:8091/product/detail/list2", { id, ids,pageNum:that.currentPage,pageSize:12 })
        .then((response) => {
          // 创建独立的数组副本
          that.shopList = [...response.data.list];
          that.total = response.data.total;
        });
    },
    // 跳转到详情页
    toInfo(row) {
      this.$router.push({
        name: "ShopInfo", // 使用路由name（不是path！）
        params: {
          rowData: {id:row.id,name:row.name}, // 数据通过params传递
        },
      });
    },
  },
  created() {
    this.getAllLevel();
    this.getList();
  },
};
</script>
<style scoped>
.empty {
  width: 100%;
  height: 400px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
}
.banner-img {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 180px;
  margin-bottom: 22px;
}
.banner-img img {
  width: 100%;
  height: 600px;
  backdrop-filter: color(100% 100%);
}
.flex {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.curpoint {
  cursor: pointer;
}
.shop-title {
  color: red;
  font-size: 16px;
}
.el-pagination {
  text-align: center;
}
/* 全局基础样式 */
.min-h-screen {
  min-height: 800px;
}
.bg-gray-50 {
  background-color: #f9fafb;
}

/* 主导航 */
nav.bg-white {
  background-color: #fff;
}
nav.shadow {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06);
}
.max-w-7xl {
  max-width: 90%;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 1rem;
}
.h-12 {
  height: 3rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
  margin-right: 1rem;
}

/* 导航链接样式 */
.hover\:text-blue-600:hover {
  color: #2563eb;
}
.text-blue-600 {
  color: #2563eb;
}
.text-gray-600 {
  color: #4b5563;
}

/* 子导航 */
.border-t {
  border-top-width: 1px;
  border-color: #e5e7eb;
}
.py-3 {
  padding-bottom: 0.75rem;
}
.py-3 a {
  margin-right: 1rem;
  cursor: pointer;
}
.text-gray-500 {
  color: #6b7280;
  margin-right: 1rem;
  width: 100px;
}
.w-20 {
  width: 5rem;
}
.gap-4 {
  gap: 1rem;
}

/* 商品列表 */
.grid {
  display: grid;
}
.grid-cols-4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.gap-6 {
  gap: 1.5rem;
}
.bg-white {
  background-color: #fff;
}
.p-4 {
  padding: 1rem;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.shadow-sm {
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}
.aspect-w-1.aspect-h-1 {
  position: relative;
}
.aspect-w-1.aspect-h-1::before {
  content: "";
  display: block;
  padding-bottom: 100%;
}
.aspect-w-1.aspect-h-1 > * {
  position: absolute;
  top: 0;
  left: 0;
  width: 96%;
  height: 96%;
}
.aspect-w-1.aspect-h-1lg > * {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.twoimg {
  border: 1px solid #ccc;
}
.overflow-hidden {
  overflow: hidden;
}
.rounded-md {
  /* border-radius: 0.375rem; */
}
.object-cover {
  object-fit: cover;
}
.object-top {
  object-position: top;
}
.hover\:scale-110:hover {
  transform: scale(1.1);
}
.transition-transform {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

/* 文字样式 */
.text-gray-900 {
  color: #111827;
}
.text-sm {
  font-size: 0.875rem;
}
.font-medium {
  font-weight: 500;
}
.text-red-600 {
  color: #dc2626;
}
.text-lg {
  font-size: 1.125rem;
}
.text-xl {
  font-size: 1.25rem;
}
.font-bold {
  font-weight: 700;
}

/* 分页 */
.py-8 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}

/* 自定义间距 */
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.space-x-8 > * + * {
  margin-left: 2rem;
}
</style>



// WEBPACK FOOTER //
// src/components/children/ShopView/ShopPage.vue